// Binds Firestore queries to Vuex state (replaces vuexfire, which doesn't support Vuex 4).
// Same API as vuexfire: wrap an action with firestoreAction() to receive bindFirestoreRef /
// unbindFirestoreRef in its context, and register firestoreBindingMutations on the root store.
const SET_VALUE = "firestoreBindingSetValue";

// Active listeners per module state object, then per state key.
const listeners = new WeakMap();

// Like vuexfire, expose the document id without making it part of the document's data.
function defaultSerialize(doc) {
  const data = doc.data();
  Object.defineProperty(data, "id", { value: doc.id });
  return data;
}

function unbind(state, key, { reset = true } = {}) {
  const stateListeners = listeners.get(state);
  if (!stateListeners || !stateListeners[key]) {
    return;
  }

  stateListeners[key]();
  delete stateListeners[key];
  if (reset) {
    state[key] = [];
  }
}

function bind({ state, commit }, key, query, { serialize = defaultSerialize } = {}) {
  unbind(state, key, { reset: false });
  if (!listeners.has(state)) {
    listeners.set(state, {});
  }

  // Resolves once the first snapshot is in the state, then keeps it in sync.
  return new Promise((resolve, reject) => {
    listeners.get(state)[key] = query.onSnapshot(
      (snapshot) => {
        const data = snapshot.docs ? snapshot.docs.map(serialize) : snapshot.exists ? serialize(snapshot) : null;
        commit(SET_VALUE, { target: state, key, data }, { root: true });
        resolve(data);
      },
      (error) => {
        console.error(`Firestore binding "${key}" failed:`, error);
        reject(error);
      },
    );
  });
}

export function firestoreAction(action) {
  return (context, payload) =>
    action(
      {
        ...context,
        bindFirestoreRef: (key, query, options) => bind(context, key, query, options),
        unbindFirestoreRef: (key, options) => unbind(context.state, key, options),
      },
      payload,
    );
}

export const firestoreBindingMutations = {
  [SET_VALUE](_state, { target, key, data }) {
    target[key] = data;
  },
};
